// Block color palettes for the cosmetics shop. Each palette is 9 puzzle colors
// (hex), mapped onto the global CSS vars --game-c1..9 by cosmetics.ts. The order
// of `colors` is the color index 1..9 the games render with, so keep every
// palette's 9 tints clearly distinguishable - these are puzzle colors, not mood
// colors. IDs are stable and stored in Firestore docs: never rename one.

export interface PaletteDef {
  id: string;
  name: string;
  /** Exactly 9 base colors (hex). Order = color index 1..9. */
  colors: [string, string, string, string, string, string, string, string, string];
}

export const PALETTES: PaletteDef[] = [
  {
    id: "default",
    name: "Candy",
    // Same values as the :root --game-c* defaults in style.css.
    colors: ["#ff5b4d", "#4a94ff", "#3bce6b", "#ffc72e", "#9d66ff", "#ff8a3c", "#23c3e6", "#ff6fae", "#c9e05e"],
  },
  {
    id: "pastel",
    name: "Pastel",
    colors: ["#ff9f93", "#8fbaff", "#9be7ad", "#ffe08a", "#c9a9ff", "#ffc39e", "#a4e7f2", "#ffb3d4", "#dced9a"],
  },
  {
    id: "neon",
    name: "Neon",
    colors: ["#ff2d55", "#2d7bff", "#1dff85", "#ffe814", "#b026ff", "#ff6a00", "#00e5ff", "#ff36c9", "#b6ff1a"],
  },
  {
    id: "retro",
    name: "Retro",
    colors: ["#c0453b", "#4b7a8a", "#6f8f4e", "#e0a836", "#7a5a86", "#d17a3c", "#5fa3a0", "#c77f8f", "#a7a44b"],
  },
  {
    id: "oceaan",
    name: "Oceaan",
    colors: ["#ff7a5c", "#1f7ae0", "#2bb3a3", "#f2d06b", "#5a6fce", "#ff9e3d", "#35c9d6", "#e77fae", "#9ccf6a"],
  },
  {
    id: "contrast",
    name: "Hoog contrast",
    // Okabe-Ito colour-blind-safe set + two neutrals; distinguishable under
    // deuteranopia/protanopia (and by luminance under full color blindness).
    colors: ["#d55e00", "#0072b2", "#009e73", "#f0e442", "#cc79a7", "#e69f00", "#56b4e9", "#1a1a1a", "#9a9a9a"],
  },
];

const byId = new Map(PALETTES.map((p) => [p.id, p]));

/** Look up a palette by id; unknown id falls back to the default palette. */
export function getPalette(id: string): PaletteDef {
  return byId.get(id) ?? PALETTES[0];
}
